/**
 * @param LoginForm Base widget for extending
 * @returns EnrollLoyaltyToBuyLoginForm widget
 */
function EnrollLoyaltyToBuyLoginFormClassCreator(LoginForm: import('widgets/forms/ajax/LoginForm').TLoginForm) {
    class EnrollLoyaltyToBuyLoginForm extends LoginForm {
        /**
         * @description Handles server response
         * @param data - Server JSON response once form submitted
         */
        onSubmitted(data) {
            if (data.success) {
                this.emit('enrollloyaltytobuyformsubmit', data);
            }

            super.onSubmitted(data);
        }

        /**
         * @description Handles GTM tracking updates
         */
        handleGTMUpdates(eventName: string, data = {}) {
            this.emit('handlegtmupdates', eventName, data);
        }
    }

    return EnrollLoyaltyToBuyLoginForm;
}

export type TEnrollLoyaltyToBuyLoginForm = ReturnType<typeof EnrollLoyaltyToBuyLoginFormClassCreator>;

export type TEnrollLoyaltyToBuyLoginFormInstance = InstanceType<TEnrollLoyaltyToBuyLoginForm>;

export default EnrollLoyaltyToBuyLoginFormClassCreator;
